module.exports = __webpack_public_path__ + "img/sam.6979d465.png";